exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#parent .hidden-child[data-v-3a64302a]{display:none}#parent:hover .hidden-child[data-v-3a64302a]{display:flex}", ""]);

// exports
